import React , { Component} from 'react';
import './App.css';
import Layout from './statefull/Layout/Layout';
import Builder from './statefull/Builder/Builder';
import Checkout from './statefull/Checkout/Checkout';
// import Blog from './containers/Blog/Blog';
import {BrowserRouter,Route, Redirect } from 'react-router-dom';
import Orders from './statefull/Orders/Orders';
import Authentication from './statefull/Authentication/Authentication';
import Logout from './statefull/Authentication/Logout/Logout';
import { connect } from 'react-redux';
import * as actionsTypes from './redux-store/redux-actions/redux-actions';

class App extends Component {

  componentDidMount(){
    this.props.checkIsAuthenticated();
  }

  render() {
    let shouldRedirect = null;
    if(!this.props.token){
        shouldRedirect = <Redirect to="/login" /> ;
    }
    return (
      // <BrowserRouter basename="my-app">
      <BrowserRouter>
        <div className="App">
          <Layout>
            {shouldRedirect}
            <Route path="/burgerBuilder" exact component={Builder}/>
            <Route path="/orders" exact component={Orders}/>
            <Route path="/login" exact component={Authentication}/>
            <Route path="/checkout" component={Checkout}/>
            <Route path="/logout" component={Logout}/>
          </Layout>
        </div>
      </BrowserRouter>
    );
  }
}

const mapProps = (state) => {
  return {
    ...state.AuthReducer
  }
}

const mapDispatchtoProps = (dispatch) => {
  return {
    checkIsAuthenticated : () => dispatch(actionsTypes.checkTokenAvailableInLocal())
  }
}

export default connect(mapProps,mapDispatchtoProps)(App);
